import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Welcome from "./pages/Welcome";
import ChapterView from "./pages/ChapterView";
import ChapterEdit from "./pages/ChapterEdit";
import Login from "./pages/Login";
import UpdatePassword from "./pages/UpdatePassword";
import ChapterList from "./pages/ChapterList";
import ChapterDelete from "./pages/ChapterDelete";
import axios from "axios";

const base = process.env.REACT_APP_API_BASE;

// Set the base URL for all axios requests
axios.defaults.baseURL = base;

// Add token to all requests if it exists
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Protected Route component - only for edit routes
const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("token");
  if (!token) {
    return <Navigate to="/login" />;
  }
  return children;
};

function App() {
  return (
    <Router basename="/">
      <Routes>
        <Route path="/" element={<Welcome />} />
        <Route path="/chapter/:id" element={<ChapterView />} />
        <Route path="/login" element={<Login />} />
        <Route path="/update-password" element={<UpdatePassword />} />
        <Route
          path="/logout"
          element={
            <ProtectedRoute>
              {() => {
                localStorage.removeItem("token");
                window.location.href = "/";
                return null;
              }}
            </ProtectedRoute>
          }
        />

        {/* Protected routes */}
        <Route
          path="/chapter/list"
          element={
            <ProtectedRoute>
              <ChapterList />
            </ProtectedRoute>
          }
        />
        <Route
          path="/chapter/:id/edit"
          element={
            <ProtectedRoute>
              <ChapterEdit />
            </ProtectedRoute>
          }
        />
        <Route
          path="/chapter/new/edit"
          element={
            <ProtectedRoute>
              <ChapterEdit isNewChapter={true} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/chapter/:id/edit/delete"
          element={
            <ProtectedRoute>
              <ChapterDelete />
            </ProtectedRoute>
          }
        />

        {/* Catch-all route for unauthorized access */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );
}

export default App;
